var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalogu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.3121 0.386719H7.7C3.104 0.386719 0.5 2.99072 0.5 7.58671V20.1868C0.5 24.7827 3.104 27.3867 7.7 27.3867H20.3121C24.908 27.3867 27.5 24.7827 27.5 20.1868V7.58671C27.5 2.99072 24.908 0.386719 20.3121 0.386719Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.619 13.0526V8.26997C20.619 7.21497 20.1688 6.79297 19.0505 6.79297H16.2091C15.0908 6.79297 14.6406 7.21497 14.6406 8.26997V13.0526C14.6406 14.1076 15.0908 14.5296 16.2091 14.5296H19.0505C20.1688 14.5296 20.619 14.1076 20.619 13.0526Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2361 14.602V19.3847C13.2361 20.4397 12.786 20.8617 11.6677 20.8617H8.82625C7.70795 20.8617 7.25781 20.4397 7.25781 19.3847V14.602C7.25781 13.547 7.70795 13.125 8.82625 13.125H11.6677C12.786 13.125 13.2361 13.547 13.2361 14.602Z",
    fill: "#CE2600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.619 19.3838V17.4145C20.619 16.3595 20.1688 15.9375 19.0505 15.9375H16.2091C15.0908 15.9375 14.6406 16.3595 14.6406 17.4145V19.3838C14.6406 20.4388 15.0908 20.8608 16.2091 20.8608H19.0505C20.1688 20.8608 20.619 20.4388 20.619 19.3838Z",
    fill: "#CE2600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.2361 10.2393V8.26997C13.2361 7.21497 12.786 6.79297 11.6677 6.79297H8.82625C7.70795 6.79297 7.25781 7.21497 7.25781 8.26997V10.2393C7.25781 11.2943 7.70795 11.7163 8.82625 11.7163H11.6677C12.786 11.7163 13.2361 11.2943 13.2361 10.2393Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogu);
export default __webpack_public_path__ + "static/media/catalogu.ab4a241d1cffbf8c0381b48c465646a2.svg";
export { ForwardRef as ReactComponent };